// extracted by mini-css-extract-plugin
module.exports = {"slider__empty-message":"_-2821yJ","slider-container--two-items":"_-3e7TLZ","slider-container--one-item":"_-3QYSda"};